import React from 'react';
import axios from "../../plugins/axios";
import { format } from "date-fns";
import {
    TextField,
    Typography,
    Table,
    TableCell,
    TableBody,
    TableHead,
    TableRow,
    Card,
    CardContent,
    Paper,
    Button,
} from "@mui/material";

const apiUrl = process.env.REACT_APP_WORKNEST_TOOLS_API_URL;

const Visits = ({visits, setVisits, setCurrentTab}) => {

    const updateVisitMinutes = (visitId, minutes) => {
        setVisits(visits.map((v) => (v.id === visitId ? { ...v, minutes } : v)));
    };

    const confirmVisit = async (visit) => {
        setVisits(visits.map((v) => (v.id === visit.id ? { ...v, submitting: true } : v)));
        await axios.post(`${apiUrl}/confirmVisitMinutes`, visit);
        if (visits.length === 1)
            setCurrentTab("daily");
        setVisits(visits.filter((v) => v.id !== visit.id));
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Visit Write-up Time
                </Typography>
            </CardContent>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Account</TableCell>
                            <TableCell align="center">VisitDate</TableCell>
                            <TableCell align="center">Write-up Minutes</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {visits.map((visit) => (
                            <TableRow key={visit.id}>
                                <TableCell>{visit.accountName}</TableCell>
                                <TableCell align="center">
                                    {format(new Date(visit.visitDate), "dd/MM/yy")}
                                </TableCell>
                                <TableCell align="center">
                                    {visit.vrfComplete ? (
                                        <TextField
                                            size="small"
                                            type="number"
                                            value={visit.minutes || ""}
                                            inputProps={{ style: { textAlign: "center" } }}
                                            onChange={(e) =>
                                                updateVisitMinutes(visit.id, e.target.value)
                                            }
                                        />
                                    ) : (
                                        "Awaiting VRF"
                                    )}
                                </TableCell>
                                <TableCell align="center">
                                    {visit.vrfComplete && (
                                        <Button
                                            variant="contained"
                                            disabled={visit.submitting || !visit.minutes}
                                            onClick={() => confirmVisit(visit)}
                                        >
                                            {visit.submitting ? "sending .." : "Confirm"}
                                        </Button>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </Card>
    );
};

export default Visits;
